import storage from 'didi-store'
import { trackEvent } from '@/common/utils/log'

// 检查两个版本更新判断
export function checkVersion (current = '', newVersion = '') {
  if (!current || !newVersion) return false
  const currentArg = current.split('.')
  const newVersionArg = newVersion.split('.')
  const isUpgrade = currentArg.reduce((flag, item, index) => {
    const curCode = parseInt(item, 10)
    const newCode = parseInt(newVersionArg[index], 10)
    return newCode > curCode || flag
  }, false)
  return isUpgrade
}

// 更新上次版本缓存
export function updateLastNewVersionName (versionName = '') {
  if (!versionName) return
  storage.set('last_new_version_name', versionName)
}

// 与上次新版本是否一致
export function isEqualLastNewVersionName (versionName) {
  const lastVersion = storage.get('last_new_version_name')
  return lastVersion === versionName
}

// 缓存上次不一样版本的时间戳
export function updateLastNewVersionTimestamp (time) {
  if (!time) return
  storage.set('last_new_version_timestamp', time)
}

// 是否支持弹窗
export function isCanUpgradePopupShow (current, newVersionName) {
  if (!checkVersion(current, newVersionName)) return false
  const period = 86400000 // 一天(目前可以设置成1分钟，比较好测试)
  const twoDayTimeDuration = period * 2
  const now = Date.now()
  const lastNewVersionTimeStamp = storage.get('last_new_version_timestamp') || 0
  let isUpgrade = false
  if (now - lastNewVersionTimeStamp >= twoDayTimeDuration) {
    updateLastNewVersionTimestamp(now)
    isUpgrade = true
  }
  return isUpgrade
}

export function sailingGattarmanXpageCk (posId, posDesc) {
  trackEvent('sailing_gattarman_x_page_ck', {
    bd_user_name: storage.get('uname'),
    pos_id: posId,
    pos_desc: posDesc
  })
}
